import { Reducer } from 'redux';
import { PaletteMode } from '../../Themes';
import { TypedStorage } from '../../Utils/TypedStorage';

import { ILayoutState, LayoutActionTypes } from './Types';

let initialTheme:PaletteMode = TypedStorage.get('theme', PaletteMode.DARK)
const initialState: ILayoutState = {
    drawerContent: null,
    pageContent: null,
    showDrawer: true,
    pageName: ' ',
    theme: initialTheme
};

const reducer: Reducer<ILayoutState> = (state = initialState, action) => {
    switch (action.type) {
        case LayoutActionTypes.DRAWER_SHOW: {
            return { ...state, showDrawer: true };
        }
        case LayoutActionTypes.DRAWER_HIDE: {
            return { ...state, showDrawer: false };
        }
        case LayoutActionTypes.SET_DRAWER_CONTENT: {
            return { ...state, drawerContent: action.payload };
        }
        case LayoutActionTypes.SET_PAGE_CONTENT: {
            return { 
                ...state, 
                pageContent: action.payload[0],
                pageName: action.payload[1]
            };
        }
        case LayoutActionTypes.SET_THEME: {
            TypedStorage.set('theme', action.payload);
            return {
                ...state,
                theme: action.payload
            }
        }
        default: {
            return state;
        }
    }
};

export { reducer as LayoutReducer };
